module.exports = "<header class=\"header\">\r\n  <lfwms-menu></lfwms-menu>\r\n  <lfwms-profile></lfwms-profile>\r\n</header>"


//////////////////
// WEBPACK FOOTER
// /home/runner/work/fbm-fulfillment-wms-client/fbm-fulfillment-wms-client/src/app/layout/home/header/header.component.html
// module id = ../../../../../src/app/layout/home/header/header.component.html
// module chunks = main